const homepage = {
    title: 'Home',
    description:
        "Connecting people's brands with today's online customers by developing intuitive web experience.",
}

export default homepage
